import { Skeleton, Button } from '@radix-ui/themes';
import { Link } from 'react-router-dom';
import type { ClubPageType } from 'types/club';
import Container from './Container';

export const ClubBaseStatistics: React.FC<
  Partial<ClubPageType> & {
    loading: boolean;
  }
> = ({ members_counter, competitions, draws, id, loading }) => {
  const itemClassName = 'bg-white gap-2 p-3 rounded-xl border border-solid border-neutral-neutral-2';
  const labelClassName = 'self-stretch text-neutral-neutral-8 text-sm  font-medium tracking-normal';
  const contentClassName =
    'flex justify-between self-stretch text-neutral-neutral-alpha-12 text-3xl md:text-4xl font-bold tracking-tighter leading-9 md:leading-10';
  return (
    <Container title='Statistiche base'>
      <div id='columns' className='grid w-full grid-cols-1 flex-wrap items-start gap-2 self-stretch md:grid-cols-3'>
        <div id='members' className={itemClassName}>
          <div id='title1' className={labelClassName}>
            Tesserati
          </div>
          <Skeleton loading={loading} className='h-10 w-20'>
            <div id='value1' className={contentClassName}>
              {members_counter}
              <Link className='flex self-end' to={`/circolo/${id}/membri`}>
                <Button variant='outline' size='2' className='cursor-pointer'>
                  Vedi
                </Button>
              </Link>
            </div>
          </Skeleton>
        </div>
        <div id='tournaments' className={itemClassName}>
          <div id='title2' className={labelClassName}>
            Tornei
          </div>
          <Skeleton loading={loading} className='h-10 w-20'>
            <div id='value2' className={contentClassName}>
              {competitions?.length || 0}
              <Link className='flex self-end' to={`/circolo/${id}/competizioni`}>
                <Button variant='outline' size='2' className='cursor-pointer'>
                  Vedi
                </Button>
              </Link>
            </div>
          </Skeleton>
        </div>
        <div id='teamCompetitions' className={itemClassName}>
          <div id='title3' className={labelClassName}>
            Competizioni a squadre
          </div>
          <Skeleton loading={loading} className='h-10 w-20'>
            <div id='value3' className={contentClassName}>
              {draws?.length || 0}
              <Link className='flex self-end' to={`/circolo/${id}/competizioni`}>
                <Button variant='outline' size='2' className='cursor-pointer'>
                  Vedi
                </Button>
              </Link>
            </div>
          </Skeleton>
        </div>
      </div>
    </Container>
  );
};

export default ClubBaseStatistics;
